export default "__VITE_ASSET__b78a08cd__"